import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Loader, SimpleTabs } from 'components';
import { FindLoad } from 'utils';
import { LibraryGoalDetailInfo } from './libraryGoalDetailInfo';
import { LibraryGoalDetailsHeader } from './libraryGoalDetailsHeader';
import { libraryActions } from 'store';
import { LibraryGoalTargetDetail } from './libraryGoalTargets';
import { LibraryGoalMastery } from './libraryGoalMastery';

const goalDetailsLabels = [{ label: 'Details' }, { label: 'Targets' }, { label: 'Mastery' }];

const ACTION_TYPE = 'GET_LIBRARY_GOAL_BY_ID';

export const LibraryGoalDetails = ({ goalId, requestParams, afterSuccess }) => {
    const [tab, setTab] = useState('Details');
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (goalId) {
            dispatch(libraryActions.getLibraryGoalById(goalId));
        }
    }, [dispatch]);

    const tabsContent = [
        {
            tabComponent: <LibraryGoalDetailInfo />,
            tab: 'Details',
        },
        {
            tabComponent: <LibraryGoalTargetDetail />,
            tab: 'Targets',
        },
        {
            tabComponent: <LibraryGoalMastery />,
            tab: 'Mastery',
        },
    ];

    if (loader?.length) {
        return (
            <div style={{ width: 1400, maxWidth: '100%' }}>
                <Loader type={'page'} />
            </div>
        );
    }

    return (
        <div style={{ width: 1400, maxWidth: '100%' }}>
            <LibraryGoalDetailsHeader requestParams={requestParams} afterSuccess={afterSuccess} />
            <SimpleTabs tab={tab} getTab={setTab} tabsLabels={goalDetailsLabels} tabsContent={tabsContent} />
        </div>
    );
};
